module.exports = __webpack_public_path__ + "img/UI_RMYX_biaoqian_02_0dd3e4f42.png";